import React from 'react';
import Sectitle from "./Title/Sectitle";

export default function Contacts2() {
  return (
      <section className="contact_info_area sec_pad bg_color" id="contact">
        <div className="container">
          <Sectitle sClass="sec_title text-center mb_70" Title="Contact Us"
                    tClass="t_color3"
                    TitleP="Let us turn your ideas into business changing software solutions."/>

          <div className="row">
            <div className="col-lg-3 mx-auto">
              {/* <div className="contact_info_item">
                <h6 className="f_p f_size_20 t_color3 f_500 mb_20">Office
                  Address</h6>
                <p className="f_400 f_size_15">Melbourne’s GPO 434 Bourke St.
                  Dhaka VIC 3074, Australia</p>
              </div> */}
              <div className="contact_info_item">
                {/* <h6 className="f_p f_size_20 t_color3 f_500 mb_20">Contact
                  Info</h6> */}
                {/* <p className="f_400 f_size_15"><span
                    className="f_400 t_color3">Phone:</span> <a
                    href="tel:3024437488">(+096) 302 443 7488</a></p>
                <p className="f_400 f_size_15"><span
                    className="f_400 t_color3">Fax:</span> <a
                    href="tel:3024437488">(+096) 204 353 6684</a></p> */}
                <p className="f_400 f_size_15"><span
                    className="f_400 t_color3">Email:</span> <a
                    href="mailto:contact@nyko.co.uk">info@nyko.co.uk</a>
                </p>
              </div>
            </div>
          </div>

        </div>
      </section>
  )
}
